import React, {useState} from 'react';
import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import {Box, Paper, TextField, Typography} from '@material-ui/core'
import SyncOffice from './syncOffice.png'
import {ApiPostData} from "@project/shared/src/services/ApiPostData";
import {commonValidation} from "@project/shared/src/services/commonValidation";
import {toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {BaseLink, BaseServer, BaseServerWebsite} from "@project/shared/src/services/postData";
import MaterialUiButtons from "@project/shared/src/components/button/materialUiButton";
import DialogBoxV2 from "@project/shared/src/components-v2/dialogBox/dialogBoxV2";
import {
  employeeMain,
  employeePrimary,
  employeePrimaryShadow,
  employeeSecondary,
  greenColor,
  redColor,
} from "@project/shared/src/colorCode/colorCode";
import MaterialUiInputHooks from "@project/shared/src/components/material-ui-input-hooks";
import MaterialUiCheckbox from "@project/shared/src/components/materialUiCheckbox/materialUiCheckbox";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import UsersAnim from "@project/shared/src/Animation/usersAnim";
import {nodePostLink} from "@project/shared/src/services/nodePost";
import {Spinner} from "react-preloading-component";
import axios from "axios";

const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          border: "1px solid #66afe9 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
        },
      },
    },
  },
  typography: {fontFamily: ['"Montserrat", sans-serif'+'!important'].join(','),},
});


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    textAlign: 'left',
  },
  saveBtn:{
    background:'#045e06',
    color:'white'
  },
  paper: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },

  customTextField :props=>({
    "& >label":{
      // background:'white',
    },
    "& .MuiSelect-icon":{
      position:"inherit",
      cursor:"pointer"
    },
    "&>div>fieldset>legend":{
      background:'white'
    },
    "& .MuiIconButton-root:focus":{
      outline:"none"
    },
    "& >div>svg":{
      right:props.iconData!==undefined?
        props.iconData.length===2?62:props.iconData.length===1?41:props.iconData.length===3?84:""
        :"",
    },
  }),

  errorStyle:{
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-19px',
  },
}));
const fields = {
  email: {value: '', valid: false, errorLabel: 'Enter Valid Email', error: ''}

};
const activation = {
  password: {value: '', valid: false, errorLabel: 'Enter Valid OTP', error: ''},
  rePassword:{value: '', valid: false, errorLabel: 'Enter Valid OTP', error: ''},
  checkedStatus:{value:false }
};


const ForgotPassword = () => {
  const classes = useStyles();
  const [modalStatusData, setModalStatusData] = React.useState({status:false});
  const [modalStatusOTP, setModalStatusOTP] = React.useState({status:false});
  const [modalStatusEmail, setModalStatusEmail] = React.useState({
      status:false,
    });
  const [modalStatusPassword, setModalStatusPassword] = React.useState({
      status:false,
    });
  const [Field, setField] = React.useState({...fields});
  const [activationField, setActivationField] = React.useState({...activation});
  const [emailData, setEmailData] = React.useState([]);
  const [formValid, setFormValid] = React.useState(false);
  const [licenceList, setLicenceList] = React.useState([]);
  const [otp, setOtp] = React.useState();
  const [sentOTPData,setSentOTPData]=useState([]);
  const [viewStatus, setViewStatus] = useState({password:false,rePassword:false});
  const [licenceVal, setlicenceVal] = useState('');
  const [loader, setLoader] = useState(false);

  const propsDrawer = {
    background: employeePrimary,
    boxShadow: employeePrimaryShadow,
    secondaryBg:   employeeSecondary,
    mainBg: employeeMain,
    cardIcon:<UsersAnim fill='white' stroke={employeeMain} height='45'/>
  };

  //Loader function
  const showLoader=()=>{setLoader(true);};
  const hideLoader=()=>{setLoader(false);};
  //End Loader function

  function showLicenceListForEmail(records) {
    //modal set to true to display-modalStatusEmail
    setLicenceList([...records.data]);
    let modalDrawer = {...propsDrawer};
    modalDrawer.subTitle = 'Select';
    modalDrawer.title = 'Licence List';
    modalDrawer.status = true;
    modalDrawer.width = 'xs';
    setModalStatusEmail(modalDrawer);
  }


  function getForgtLink(){
    let arryDetails ={};
    if(licenceVal) {
      licenceList.map(data => {
        if (licenceVal === data['licence_name']) {
          arryDetails['json_detail'] = data;
          ApiPostData('api/websiteApi.php', 'toSendForgotLinkOption', arryDetails).then(result => {
            // eslint-disable-next-line default-case
            switch (result.status) {
              case 2:
                toast.error('Email Id does not exist');
                break;
              case 3:
                toast.error('Account not yet activated');
                break;
              case 5:
                const update = modalStatusEmail;
                update.status=false;
                setModalStatusEmail(update);
                showEmailData(result);
                break;
            }
          });
        }
      });
    }else {
      toast.error('Select the licence');
    }

  }

  function getemailormobileno(email) {
    let data= {};
    data['email']=Field['email'].value;
    ApiPostData('api/websiteApi.php', 'getdataforpws', data).then(result => {
      switch(result.status){
        case 2:
          toast.error('Email Id does not exist');
          break;
        case 3:
          toast.error('Account not yet activated');
          break;
        case 4:
          showLicenceListForEmail(result);
          break;
        case 5:
          showEmailData(result);
          break;
      }
    });

  }


  function showEmailData(records){
    let modalDrawer={...propsDrawer};
    modalDrawer.subTitle='Select';
    modalDrawer.title='Email / Phone '
    modalDrawer.status=!modalStatusData.status;
    modalDrawer.width='xs';
    setModalStatusData(modalDrawer);
    records.data[0]['checkedValue']='';
    setEmailData([...records.data]);
  }

  function generateOtp() {

    let data = {};
    emailData.map(( value,key) => {
      if (value.checkedValue!='') {
        // eslint-disable-next-line default-case
        switch (value.checkedValue) {
          case value['mobile_num']:
            data['sendwith'] = value.mobile_num;
            data['action'] = 'sendsms';
            break;
          case Field['email']['value']:
            data['sendwith'] =Field['email']['value'];
            data['action'] = 'sendmail';
            break;
        }
        data['id'] = emailData[0]['id'];
        showLoader();
        ApiPostData('api/websiteApi.php', 'sendotp', data).then(result => {
          let modalDrawer={...propsDrawer};
          modalDrawer.subTitle='Enter';
          modalDrawer.title='OTP';
          modalDrawer.status=true;
          modalDrawer.width='xs';


          if(data.action==='sendmail'){
            if (result.status) {
              let data={email_msg:result.data[0].email_msg,email:Field.email.value};
              nodePostLink('/mailer/sendemail/forgotPasswordEmail',data).then((emailAdminResult) => {
                if(emailAdminResult.status){
                  setModalStatusData({status:false});
                  setSentOTPData([...result.data]);
                  setModalStatusOTP(modalDrawer);
                  hideLoader();
                }else{
                  toast.error("Error while sending Email");
                  hideLoader();
                }
              }).catch(function (response) {
              });
            } else {
              toast.error('OTP not sent');
              hideLoader();
              return false;
            }
          }else{
            let data={msg:result.data[0].message,mobile_num:value.mobile_num};
            nodePostLink('/sms/sendSMS/forgotPasswordOTP',data).then((emailAdminResult) => {
              if(emailAdminResult.status){
                setModalStatusData({status:false});
                setSentOTPData([...result.data]);
                setModalStatusOTP(modalDrawer);
                hideLoader();
              }else{
                toast.error("Error while sending SMS");
                hideLoader();
              }
            }).catch(function (response) {
            });
          }
        });
      } else {
        toast.error('Choose the Option');
        return false;
      }
    });
  }




  const changeInField = (e, fieldname,validationType) => {
    let updateForm = {...Field};

    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;
    updateFormField.valid = commonValidation(e.target.value, validationType);
    let formValidVar = true;
    updateForm[fieldname] = updateFormField
    setField({...updateForm});
    for (let key in Field) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setFormValid(formValidVar)
  }

  const changeInActivation = (e, fieldname) => {
    let updateForm = {...activationField};
    let updateFormField = updateForm[fieldname];
    if (fieldname === 'checkedStatus') {
      updateFormField.value = e.target.checked;
    } else {
      updateFormField.value = e.target.value;
    }

    setActivationField(updateForm);
  }

  const licenceListStructure=(data,index)=>{
    return (
      <Box className="border-bottom" key={index}>
        <FormControlLabel value={data.licence_name}  control={<Radio />} label={data.licence_name}  />
      </Box>
    );
  }

  const chnageCheckBoxLicence=(event,index)=>{
    setlicenceVal(event.target.value);
  }

  const emailDataRadio=(event)=>{
    emailData[0]['checkedValue'] = event.target.value;
    setEmailData([...emailData]);
   }

   const otpChange=(event)=>{
    setOtp(event.target.value);
   }


  function checkotpverification() {
    var d = new Date();
    var time = Math.round(d.getTime()/1000);

    let modalDrawer={...propsDrawer};
    modalDrawer.subTitle='Reset';
    modalDrawer.title='Password'
    modalDrawer.status=!modalStatusPassword.status;
    modalDrawer.width='xs';

    if(time>sentOTPData[0]['expire']){
      setModalStatusOTP({status:false});
      toast.error('OTP Expired');
    }else{
      if(otp == sentOTPData[0]['otp']&& sentOTPData[0]['id']==emailData[0]['id']){
        setModalStatusOTP({status:false});
        setModalStatusPassword(modalDrawer);
      }else{
        toast.error('Invalid OTP');
      }
    }
      }


  function resetPwd()
  {

    var regex = /^((?=.*\d)(?=.*[a-z])|(?=.*\d)(?=.*[A-Z])).{6,25}$/;
    var regex1 = /^\S*$/;
    var new_pass = activationField['password'].value;
    var re_enter_pass = activationField['rePassword'].value;
    var prop_check = activationField["checkedStatus"].value;
    if (new_pass == "")
    {
      toast.error('Enter the Password');
      return false;
    }
    if (!regex.test(new_pass) || !regex1.test(new_pass))
    {
      toast.error('Password is not strong');
      return false;
    }
    else if (re_enter_pass == "")
    {
      toast.error("Enter password");
      return false;
    }
    else if (new_pass != re_enter_pass)
    {
      toast.error("password doesn't match");
      return false;
    }
    else if(!prop_check)
    {
      toast.error("Accept the Term and Conditions");
      return false;
    }


    var resetPwdDetalis = {};
    resetPwdDetalis['user_id'] =emailData[0]['id'];
    resetPwdDetalis['licenceId'] =emailData[0]['licenceId'];
    resetPwdDetalis['type'] = emailData[0]['type'];
    resetPwdDetalis['password'] = new_pass;
    resetPwdDetalis['email'] = Field['email'].value;
    let data={};



    data['json_detail']=resetPwdDetalis;

    ApiPostData('api/websiteApi.php', 'resetpwd', data).then(result => {

      if (result == 1)
      {
        toast.success('Password has been changed successfully');

        setTimeout(() => {
          window.location = `${BaseServer}login`;
        }, 3000);


      }
      else {
        toast.error('Password Not updated');

        setTimeout(() => {
          window.location = `${BaseServer}login`;
        }, 3000);
      }

    });



  }

  function showPassword(field)
  {
    let updateForm = {...viewStatus};
    updateForm[field]=!updateForm[field];
    setViewStatus({...updateForm})

  }

  return (
    <MuiThemeProvider theme={theme}>
      <Box>
        {
          loader?
            <Box style={{position: 'fixed', top: 0, left: 0,bottom:0,right:0,background: '#80808061',zIndex: 1500}}>
              <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'100%'}>
                <Spinner/>
              </Box>
            </Box>
            :""
        }
      </Box>
      <Box className={classes.root} pt={2} px={3} >
        <img src={SyncOffice} alt='SyncOffice' style={{height: 100}}/>

        <Paper className={classes.paper}>
          <Typography variant="h5" color='textPrimary'>
            First, Let's find your account
          </Typography>

          <form className={classes.form} noValidate autoComplete="off">
            <Box mt={3}>
              <TextField
                label='Username'
                variant='outlined'
                size='small'
                fullWidth
                className={classes.customTextField}
                value={Field['email']['value']}
                onChange={(event) => changeInField(event, 'email',{required: true, validationType: 'email'})}
              />
              {!Field['email'].valid ?
                <div className={classes.errorStyle}>
                  <Typography variant="caption" style={{color: 'red'}}>
                    {Field['email'].error}
                  </Typography>
                </div>
                :
                <span></span>
              }
            </Box>
          </form>

          <Box display="flex" mt={10} justifyContent="flex-end">
            <Box mr={2}>
              <a href={`${BaseLink}${BaseServerWebsite}login`} style={{textDecoration:'none'}}>
                <MaterialUiButtons
                  color={redColor}
                  btnTitle="Cancel"
                  iconName="close"
                  btnSize="small"
                />
              </a>
            </Box>
            <Box>
              <MaterialUiButtons
                btnClick={()=>getemailormobileno()}
                color="#1b5e20"
                btnTitle="Find Account"
                btnDisable={!formValid}
                iconName='search'
                btnSize="small"
              />
            </Box>
          </Box>
        </Paper>


        <DialogBoxV2
          openDialog={modalStatusEmail.status}
          closeDialog={()=>setModalStatusEmail({status:false})}
          propsDrawer={modalStatusEmail}
          footer={true}
          footerRightBtnData={[
            {name:'Cancel',action: ()=>setModalStatusEmail({status:false}),disable:false,color:redColor,iconName:'close'},
            {name:'Send Link',
              action:()=>getForgtLink(),
              color:greenColor,
              iconName:'send'},
          ]}
        >
          <Box display="flex" alignItems="center" height={1} p={2}>
            <Box width={1} >
              <Typography variant="subtitle2" >
                <RadioGroup aria-label="Licence List" name="licence" value={licenceVal} onChange={chnageCheckBoxLicence}>

                {

                  licenceList.map(licenceListStructure)
                }
                </RadioGroup>
              </Typography>
            </Box>
          </Box>
        </DialogBoxV2>

        <DialogBoxV2
          openDialog={modalStatusData.status}
          closeDialog={()=>setModalStatusData({status:false})}
          propsDrawer={modalStatusData}
          footer={true}
          footerRightBtnData={[
            {name:'Cancel',action: ()=>setModalStatusData({status:false}),disable:false,color:redColor,iconName:'close'},
            {name:'Send OTP',
              action:()=>generateOtp(),
              color:greenColor,
              iconName:'send'},
          ]}
        >
          <Box height={1} p={2}>

            <Box textAlign="center">
              <Typography variant="body2" >
              </Typography>
            </Box>

            <Box width={1} >
              <Typography variant="subtitle2" >
                {emailData.length>0?
                  <RadioGroup aria-label="" name="optionData" value={emailData[0]['checkedValue']} onChange={emailDataRadio}>
                    <FormControlLabel className="mb-0 border-bottom" value={Field['email']['value']}  control={<Radio />} label={Field['email']['value']}  />
                    {
                      emailData[0]['mobile_num']!==''||emailData[0]['mobile_num']!==null||emailData[0]['mobile_num']!==undefined?
                        <FormControlLabel className="mb-0 border-bottom" value={emailData[0]['mobile_num']}  control={<Radio />} label={emailData[0]['mobile_num']}  />
                        :""
                    }
                  </RadioGroup>
                  :
                  ''}
              </Typography>
            </Box>
          </Box>
        </DialogBoxV2>


        <DialogBoxV2
          openDialog={modalStatusOTP.status}
          closeDialog={()=>setModalStatusOTP({status:false})}
          propsDrawer={modalStatusOTP}
          footer={true}
          footerRightBtnData={[
            {name:'Cancel',action: ()=>setModalStatusOTP({status:false}),disable:false,color:redColor,iconName:'close'},
            {name:'Submit',
              action:()=>checkotpverification(),
              color:greenColor,
              iconName:'save'},
          ]}
        >

          <Box height={1} p={2}>

            <Box textAlign="center">
              <Typography variant="subtitle2" >
                We just sent you a verification code
              </Typography>
            </Box>
            <Box>
              <MaterialUiInputHooks
                label="OTP"
                inputType="input"
                value={otp}
                propsDrawer={propsDrawer}
                change={(event)=>otpChange(event)}
              />
            </Box>
            <Box width={1} textAlign="center">
              <Typography variant="caption" >
                {
                  emailData.length>0 ?
                  !isNaN(parseFloat(emailData[0].checkedValue)) && !isNaN(emailData[0].checkedValue - 0) ?
                    ""
                    :
                    <Box>
                      We just sent a verification code to your email.If you don't see our email in your
                      inbox,check your spam folder.
                    </Box>
                    :""
                }

                <Box display="flex">
                  <Box>
                    {
                      emailData.length>0 ?
                      !isNaN(parseFloat(emailData[0].checkedValue)) && !isNaN(emailData[0].checkedValue - 0) && emailData.length>0?
                        "Didn't recieve SMS?"
                        :
                        "Didn't recieve Email?"
                        :""
                    }

                  </Box>
                  <Box pl={0.3} fontWeight="bold" onClick={()=>{
                    toast.success('OTP Sent Successfully');
                    generateOtp()
                  }
                    } style={{textDecoration:'underline',cursor:'pointer'}}>
                    Resend
                  </Box>
                </Box>
              </Typography>
            </Box>
          </Box>
        </DialogBoxV2>


        <DialogBoxV2
          openDialog={modalStatusPassword.status}
          closeDialog={()=>setModalStatusPassword({status:false})}
          propsDrawer={modalStatusPassword}
          footer={true}
          footerRightBtnData={[
            {name:'Cancel',action: ()=>setModalStatusPassword({status:false}),disable:false,color:redColor,iconName:'close'},
            {name:'Submit',
              action:()=>resetPwd(),
              color:"#1b5e20",
              iconName:'save'},
          ]}
        >
          <Box height={1} p={2}>
            <Box textAlign="center">
              <Typography variant="subtitle2" >
                Finally, choose a new password
              </Typography>
            </Box>

            <Box pt={2}>
              <TextField
                label='Email'
                variant='outlined'
                size='small'
                required
                fullWidth
                className={classes.customTextField}
                value={Field['email']['value']}
                disabled
              />
            </Box>

            <Box pt={2}>
              <MaterialUiInputHooks
                label="Password"
                inputType="input"
                value={activationField['password'].value}
                type={viewStatus['password'] ? 'text' : 'password'}
                change={(event) => changeInActivation(event, 'password')}
                required={true}
                adornment={true}
                error={activationField['password'].error}
                propsDrawer={propsDrawer}
                iconData={[
                  {tooltip:viewStatus['password']?'View Password':'Hide Password',iconName:viewStatus['password']?'visibility':'visibility_off',action:() => showPassword('password')}
                ]}
              />
            </Box>

            <Box pt={2}>
              <MaterialUiInputHooks
                label="Confirm Password"
                inputType="input"
                value={activationField['rePassword'].value}
                type={viewStatus['rePassword'] ? 'text' : 'password'}
                change={(event) => changeInActivation(event, 'rePassword')}
                required={true}
                adornment={true}
                error={activationField['rePassword'].error}
                propsDrawer={propsDrawer}
                iconData={[
                  {tooltip:viewStatus['rePassword']?'View Password':'Hide Password',iconName:viewStatus['rePassword']?'visibility':'visibility_off',action:() => showPassword('rePassword')}
                ]}
              />
            </Box>


            <Box pt={2} style={{lineHeight:0}}>
              <Typography variant="caption" style={{lineHeight:1}}>
                Password must contain at least 6 characters including at least  1 Numeric value,
                at least  1 Alphabet value,Not have any space in-between
              </Typography>
            </Box>

            <Box pt={2}>
              <MaterialUiCheckbox
                checkStatus={activationField['checkedStatus'].value}
                checkClick={(event) => changeInActivation(event, 'checkedStatus')}
                cardStyle={propsDrawer}
                label={<span> I accept <a
                  href={`${BaseLink}termsandconditions.php`} target="_blank">Terms and Conditions</a></span>}
              />

            </Box>
          </Box>
        </DialogBoxV2>

      </Box>

    </MuiThemeProvider>
  );
};

export default ForgotPassword;
